$(function () {

    // person to emploee check hiring
    $(document).on('change', '#personemployee-work_contract_position', function (e) {
        var work_contract_position = $(this).val();
        $('#hiring_id_position').val(0);
        $('#hiring_position_info').css('display', 'none');
        if (work_contract_position.length > 0) {
            console.log(work_contract_position);
            var url = $(this).data('url_hiring') + '?position_id=' + work_contract_position;
            $.when($.ajax({
                url: url,
                async: false,
                cache: false,
                success: function (data) {
                    if (data.status === 'success') {
                        console.log(data);
                        if (data.data.open_positions > 0) {
                            $('#hiringModal').modal('show');
                            $('#hiringModalContent').html(data.data.content);
                        } else {
                            return true;
                        }
                    } else {
                        bootbox.alert('Došlo k chybě při načítání informací o náborech');
                    }
                },
                error: function (data) {
                    bootbox.alert('Došlo k chybě při načítání informací o náborech');
                }, dataType: 'json'
            })).done(function (result) {
                console.log(result);
                return result;
            });
        }
        return true;
    });

    // fill #hiring_id_position by clicking on button
    $(document).on('click', '.apply_hiring', function (e) {
        e.preventDefault();
        let hiring_id = $(this).data('hire_id');
        $('#hiring_position_info').html($(this).data('hire_content'));
        $('#hiring_position_info').css('display', 'block');
        $('#hiring_id_position').val(hiring_id);
        $('#hiringModal').modal('hide');
    });

    $(document).on('click', '#absence_set_filter', function (e) {
        e.preventDefault();
        document.location = $(this).attr('href') + '?filter_range=' + $('#filter_daterange').val() + '&stat_type=' + $('#filter_stat_type').val();
    });

    $(document).on('click', '#canceled_set_filter', function (e) {
        e.preventDefault();
        document.location = $(this).attr('href') + '?filter_range=' + $('#filter_daterange').val();
    });

    $(document).on('click', '#save_person_note', function (e) {
        e.preventDefault();
        $('#noteAddModal').modal('hide');
        var form = $(this).closest('form');
        var url = form.attr('action');
        var form_data = form.serialize();
        console.log(form_data);
        $.ajax({
            type: 'POST', url: url, async: false, dataType: 'json', data: form_data,
            success: function (data) {
                if (data.status == 'success') {
                    console.log(data);
                    $('#tab-meeting').html(data.data.content);
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                bootbox.alert('Chyba při provádění operace');
            }
        });
    });

    $(document).on('click', '.update_person_note', function (e) {
        $('#noteUpdateModal').modal('show');
        var url = $(this).data('update_url');
        $('#update_note_id').val($(this).data('note_id'));
        $.ajax({
            type: 'GET', url: url, async: false, dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    console.log(data);
                    $('#update_note_content').val(data.data.content);
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                bootbox.alert('Chyba při provádění operace');
            }
        });
    });

    $(document).on('click', '#update_person_note', function (e) {
        e.preventDefault();
        $('#noteUpdateModal').modal('hide');
        var form = $(this).closest('form');
        var url = form.attr('action') + '?id=' + $('#update_note_id').val();
        var form_data = form.serialize();
        console.log(form_data);
        $.ajax({
            type: 'POST', url: url, async: false, dataType: 'json', data: form_data,
            success: function (data) {
                if (data.status == 'success') {
                    console.log(data);
                    $('#tab-meeting').html(data.data.content);
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                bootbox.alert('Chyba při provádění operace');
            }
        });
    });

    $(document).on('click', '.delete_person_note', function(e) {
        e.preventDefault();
        var url = $(this).data('delete_url');
        bootbox.confirm({
            title: 'Potvrzení',
            backdrop: true,
            message: 'Opravdu smazat poznámku?',
            buttons: {
                confirm: { label: 'Ano', className: 'btn-success' },
                cancel: { label: 'Ne', className: 'btn-danger' }
            },
            callback: function (result) {
                if (result) {
                    $.ajax({
                        type: 'POST', url: url, async: false, dataType: 'json',
                        success: function (data) {
                            if (data.status == 'success') {
                               console.log(data);
                               $('#tab-meeting').html(data.data.content);
                            } else {
                                bootbox.alert(data.msg);
                            }
                        },
                        error: function (data) { // if error occured
                            bootbox.alert(data);
                        }
                    });
                }
            }
        });
    });

    $(document).on('click', '#save_person_document', function (e) {
        $('#fileAddModal').modal('hide');
        e.preventDefault();
        var form = $(this).closest('form');
        var url = form.attr('action');
        form_data = $("#person_upload_form").get(0);
        var form_data = new FormData(form[0]); //form.serialize();
        console.log(form_data);
        $.ajax({
            type: 'POST', url: url, async: false, dataType: 'json', data: form_data, enctype: 'multipart/form-data', processData: false, contentType: false,
            success: function (data) {
                if (data.status == 'success') {
                    console.log(data);
                    $('#tab-docs').html(data.data.content);
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) { // if error occured
                bootbox.alert('Chyba při provádění operace');
            }
        });
    });

    $(document).on('click', '.delete_employee_doc', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        bootbox.confirm({
            title: 'Potvrzení',
            backdrop: true,
            message: 'Opravdu smazat dokument?',
            buttons: {
                confirm: { label: 'Ano', className: 'btn-success' },
                cancel: { label: 'Ne', className: 'btn-danger' }
            },
            callback: function (result) {
                if (result) {
                    $.ajax({
                        type: 'GET', url: url, async: false, dataType: 'json',
                        success: function (data) {
                            if (data.status == 'success') {
                                console.log(data);
                                $('#tab-docs').html(data.data.content);
                            } else {
                                bootbox.alert(data.msg);
                            }
                        },
                        error: function (data) {
                            bootbox.alert('Chyba při provádění operace');
                        }
                    });
                }
            }
        });
    });

});
